module.exports = __webpack_public_path__ + "img/icon6.3ce93007.png";